import React, { FC, useEffect, useState } from 'react';
import { Col, Form, Row, Space, Upload, UploadProps } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { RcFile } from 'antd/es/upload';
import { useParams } from 'react-router-dom';
import { api, endpoints } from '../../../../api';
import {
  CloseButton,
  CustomButton,
  CustomCheckbox,
  DownloadCol,
  FormBlock,
  FormInput,
  FormItem,
} from '../../../../styles/styled';
import { getBase64 } from '../../../../utils/convertToBase64';
import { DocumentFileResponse, FileDataType } from '../../../NewApplicationPage/types';
import { FileResponseType } from '../../../NewDocumentCategory/components/AddFIleForm/types';
import { DocumentFileType } from '../../types';

export type DocumentFileFormProps = {
  fileData: DocumentFileType;
  setForm: (id: number, res: DocumentFileType) => void;
  removeForm: (id: number) => void;
};
export const DocumentFileForm: FC<DocumentFileFormProps> = ({ fileData, setForm, removeForm }) => {
  const { id } = useParams();
  const [fileLoadState, setFileLoad] = useState<FileDataType | null>(null);
  const [loadState, setLoadState] = useState<boolean>(false);

  const [replaceState, setReplaceState] = useState<boolean>(false);

  useEffect(() => {
    if (loadState && fileLoadState) {
      (async () => {
        try {
          const response = await api.post<FileResponseType>(endpoints.addFile(), fileLoadState);
          setLoadState(false);
          if (response && !replaceState) {
            const documentFileResponse = await api.post<DocumentFileResponse>(endpoints.addDocumentFile(), {
              file: {
                id: response.data.file_id,
              },
              document: {
                id: id ? parseInt(id) : 0,
              },
              name: fileLoadState.title,
              sort: 0,
            });

            if (documentFileResponse) {
              setForm(fileData.id ? fileData.id : 1, {
                ...fileData,
                file: { id: documentFileResponse.data.document_file_id },
              });
            }
          } else {
            setForm(fileData.id ? fileData.id : 1, {
              ...fileData,
              file: { id: response.data.file_id },
            });
          }
        } catch (err) {}
      })();
    }
    // eslint-disable-next-line
  }, [loadState, fileLoadState]);

  const handleTextbook: UploadProps['onChange'] = (info) => {
    setForm(fileData.id ? fileData.id : 1, { ...fileData, name: info.file.name });

    getBase64(info.file.originFileObj as RcFile, (url) =>
      setFileLoad({
        base64: url.split('base64,')[1],
        title: info.file.name as string,
        ext: info.file.type as string,
      }),
    );
  };

  return (
    <FormBlock position="relative">
      <CloseButton positioned onClick={() => removeForm(fileData.id ? fileData.id : 1)}>
        +
      </CloseButton>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <FormItem>
            <CustomCheckbox
              checked={fileData?.expire}
              onChange={(e: CheckboxChangeEvent) =>
                setForm(fileData.id ? fileData.id : 1, { ...fileData, expire: e.target.checked })
              }
            >
              <p>Утратил силу</p>
            </CustomCheckbox>
          </FormItem>
        </Col>
        <Col span={13}>
          <FormItem redstar>
            <p>Наименование</p>
            <Form.Item
              label="Наименование"
              initialValue={fileData.name}
              rules={[{ required: true, message: 'Пожалуйста, введите наименование подраздела' }]}
            >
              <FormInput
                onChange={(e) => setForm(fileData.id ? fileData.id : 1, { ...fileData, name: e.target.value })}
                value={fileData.name}
                defaultValue={undefined}
              />
            </Form.Item>
          </FormItem>
        </Col>
        <Col span={13}>
          <FormItem>
            <p>Сортировка</p>
            <FormInput
              onChange={(e) => setForm(fileData.id ? fileData.id : 0, { ...fileData, sort: parseInt(e.target.value) })}
              value={fileData?.sort}
              type="number"
            />
          </FormItem>
        </Col>
        <DownloadCol span={24} style={{ paddingLeft: '35px' }}>
          <Space size={0} align="center">
            {(fileLoadState || fileData.file) && (
              <button
                className="remove-button"
                onClick={() => {
                  setFileLoad(null);
                  setForm(fileData.id ? fileData.id : 0, { ...fileData, file: undefined });
                  setReplaceState(true);
                }}
              >
                +
              </button>
            )}
            {!fileLoadState && !fileData.file && (
              <Upload
                accept=".pdf, .png, .jpg, .jpeg"
                onChange={handleTextbook}
                name="avatar"
                className={'avatar-uploader'}
                showUploadList={false}
              >
                <div className={'download-layout'}>Загрузить файл</div>
              </Upload>
            )}{' '}
            {(fileLoadState || fileData.file) && (
              <>
                <CustomButton padding="5px 10px" lowercase nolines width="auto">
                  {fileLoadState ? fileLoadState.title : fileData?.name}
                </CustomButton>
                {fileLoadState && <FormInput defaultValue={1} width={'60px'} type="number" />}

                {fileLoadState && (
                  <CustomButton
                    type="button"
                    onClick={() => setLoadState(true)}
                    width="auto"
                    lowercase
                    padding="5px 10px"
                  >
                    Загрузка файла
                  </CustomButton>
                )}
              </>
            )}
          </Space>
          <p>рекомендуется прикреплять файл в формате .pdf</p>
        </DownloadCol>
      </Row>
    </FormBlock>
  );
};
